<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolReportsAndAnalyticsSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: { path: '/school/reports-and-analytics/report-cards', query: { termType: 1 } },
                title: "Full-Term Report Card",
                description: "Generate full-term student results, comments and performance summaries.",
                icon: "fa fa-folder"
            },
            {
                to: { path: '/school/reports-and-analytics/report-cards', query: { termType: 2 } },
                title: "Mid-Term Report Card",
                description: "Generate mid-term student results and performance summaries.",
                icon: "fa fa-calendar-check"
            },
            {
                to: "/school/reports-and-analytics/broadsheet",
                title: "Broadsheet",
                description: "Review class results and subject grades in one summary.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/reports-and-analytics/broadsheet-per-position",
                title: "Broad Sheet Per Position",
                description: "Compare student results ranked by class position.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/reports-and-analytics/mock-report",
                title: "Mock Report Card",
                description: "Review mock examination results in report-card format.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/reports-and-analytics/financial-report",
                title: "Financial Reports",
                description: "Analyze school income, expenses, and financial activity.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/reports-and-analytics/class-attendance-report",
                title: "Class Attendance Report",
                description: "Review class attendance totals by registered term, class and section.",
                icon: "fa fa-calendar-check"
            },
            {
                to: "/school/reports-and-analytics/class-performing-ranking",
                title: "Class Performance Ranking",
                description: "Generate a ranked class results summary by student position.",
                icon: "fa fa-folder"
            },
            {
                to: { path: '/school/reports-and-analytics/student-account-statement', query: { reportType: 'student' } },
                title: "Student Account Statement",
                description: "Generate a student’s assessed fees, payments and outstanding balance.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
